export const requestProjectFiles = (environment: string, vscode: any) => {
    if (environment.includes("jetbrains")) {
        window.jetbrainsPostMessage(JSON.stringify({functionName: "getFileNames", data: []}));
    } else if (environment === "vscode") {
        vscode.postMessage({functionName: "getFileNames", data: []});
    }
}
